<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
  <g id="Layer_2">
    <path class="color" fill="#F45B5B" d="M100.184,113.656c-2.222,0.065-4.188-1.43-4.721-3.588l-7.131-28.616
      c-0.864-3.619,0.028-7.434,2.408-10.293c4.168-5.216,11.773-6.065,16.99-1.898c0.701,0.56,1.338,1.197,1.897,1.898
      c2.313,2.912,3.118,6.744,2.173,10.341l-6.895,28.568C104.373,112.227,102.407,113.722,100.184,113.656z"/>
    <circle class="color" fill="#F45B5B" cx="100.184" cy="125.462" r="7.083"/>
    <path class="color" fill="#F45B5B" d="M100.184,160.876c-33.902,0-61.385-27.483-61.385-61.385c0-33.902,27.482-61.385,61.385-61.385
      s61.386,27.483,61.386,61.385C161.569,133.393,134.086,160.876,100.184,160.876z M100.184,47.549
      c-28.686,0-51.941,23.255-51.941,51.942c0,28.687,23.256,51.941,51.941,51.941c28.688,0,51.942-23.254,51.942-51.941
      C152.126,70.804,128.871,47.549,100.184,47.549z"/>
  </g>
  </svg>

</template>

<script>
export default {
  name: 'WarningIcon'
}
</script>
